import React, { FC, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';

import { PriceSpiderProps } from './models';
import { handlePriceSpiderModalClose, removePriceSpider } from './utils';

const PriceSpider: FC<PriceSpiderProps> = ({ priceSpider, lang }) => {
  const [shouldPriceSpiderLoad, setShouldLoadPriceSpider] = useState(false);

  useEffect(() => {
    removePriceSpider();
    setShouldLoadPriceSpider(true);

    return () => {
      handlePriceSpiderModalClose();
      removePriceSpider();
    };
  }, []);

  return (
    <Helmet>
      <meta name="ps-key" content={priceSpider.key} />
      <meta name="ps-country" content={priceSpider.country} />
      <meta name="ps-language" content={lang.split('-')[0]} />
      {shouldPriceSpiderLoad ? (
        <script
          src={`${priceSpider.url}?v="${Date.now()}"`}
          type="text/javascript"
          async
        />
      ) : null}
    </Helmet>
  );
};

export default PriceSpider;
